import React from 'react';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import Promocao from 'components/promocao';


const CarrosselPromocoes = ({ lpromocoes, esconderTitulo = false }) => {

  const responsive = {
    superLargeDesktop: {
      // screens larger than 1920px
      breakpoint: { max: 4000, min: 1920 },
      items: 4
    },
    desktop: {
      // screens larger than 1024px
      breakpoint: { max: 1920, min: 1024 },
      items: 4
    },
    tablet: {
      // screens larger than 464px
      breakpoint: { max: 1024, min: 768 },
      items: 3
    },
    mobile: {
      // screens smaller than 464px
      breakpoint: { max: 768, min: 0 },
      items: 1
    }
  };

  return <>
    <div className={esconderTitulo ? '' : 'mt-4'}>
      {!esconderTitulo && <h2 className='section-title mb-3 px-2'>Promoções Especiais</h2>}
      <div className='modern-carousel'>
        <Carousel 
          responsive={responsive} 
          infinite={true}
          autoPlay={true}
          autoPlaySpeed={4500}
          arrows={true}
          showDots={false}
        >
          {lpromocoes.map(b => (
            <div key={`promo${b.id_promocao}`} className='p-2' style={{ overflow: 'hidden' }}>
              <Promocao
                promocao={b}
                index={b.id_promocao}
              />
            </div>
          ))}
        </Carousel>
      </div>
    </div>
  </>
};

export default CarrosselPromocoes;
